import theme from '@adsk/alloy-react-theme';

export const HOURS_ID = 'hours-input';
export const MINUTES_ID = 'minutes-input';
export const TIME_PERIOD_ID = 'time-period-input';
export const TIME_DROPDOWN_ID = 'time-dropdown-input';

export const DEFAULT_INCREMENT = 30;

export const disabledStyle = {
  background: theme.tokens.colors.background.neutral.inactive.value,
  borderColor: theme.tokens.colors.border.inactive.value,
  boxShadow: 'none',
  color: theme.tokens.colors.text.inactive.value,
  cursor: 'not-allowed',
};

export const TIME_PERIODS = {
  AM: 'AM',
  PM: 'PM',
} as const;

type TimePeriods = typeof TIME_PERIODS;
export type TimePeriod = TimePeriods[keyof TimePeriods];

export type InitialTime = {
  hours: number;
  minutes: number;
};

export type Hours = { hours?: number };
export type Minutes = { minutes?: number };
export type Is24Hour = { is24Hour: boolean };

export type TimePickerTime = Hours & Minutes & Is24Hour;

export type Times = Hours &
  Minutes & {
    timePeriod?: TimePeriod;
  };

export type SelectTime = {
  value: InitialTime;
  label: string;
};
